import { Container } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';
const CVContentLoader = () => {
  const isNativeSearch = useConversationWidgetStore((state) => state.isNativeSearch);
  return (
    <Container
      maxWidth="sm"
      sx={{ textAlign: 'center', position: 'fixed', top: '45%', left: '5%' }}
    >
      <CircularProgress size={50} thickness={2} />
      <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
        {isNativeSearch ? 'Syncing Candidate Details' : 'Fetching Candidate Details'}
      </WsTypography>
      <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
        {isNativeSearch
          ? ' Hold on tight for few seconds while we download the CV for you and add the candidate to your Talentpool'
          : 'Hold on tight for few seconds while we fetching the candidate details'}
      </WsTypography>
    </Container>
  );
};
export default CVContentLoader;
